/** @format */

import React from "react";
import { Container, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
	ArrowForward,
	PersonAdd,
	AttachMoney,
	Autorenew,
	CheckCircle,
} from "@mui/icons-material";
import {
	HowItWorksContainer,
	SectionTitle,
	SectionSubtitle,
	StepsContainer,
	StepCard,
	StepNumber,
	StepIconWrapper,
	StepTitle,
	StepDescription,
	ConnectorLine,
	AnimatedArrow,
} from "./styles";

const HowItWorks = () => {
	const { t } = useTranslation("home");
	const steps = [
		{
			number: "01",
			icon: <PersonAdd sx={{ fontSize: 40 }} />,
			title: t("howItWorks.step1Title"),
			description: t("howItWorks.step1Desc"),
		},
		{
			number: "02",
			icon: <AttachMoney sx={{ fontSize: 40 }} />,
			title: t("howItWorks.step2Title"),
			description: t("howItWorks.step2Desc"),
		},
		{
			number: "03",
			icon: <Autorenew sx={{ fontSize: 40 }} />,
			title: t("howItWorks.step3Title"),
			description: t("howItWorks.step3Desc"),
		},
		{
			number: "04",
			icon: <CheckCircle sx={{ fontSize: 40 }} />,
			title: t("howItWorks.step4Title"),
			description: t("howItWorks.step4Desc"),
		},
	];

	return (
		<HowItWorksContainer>
			<Container maxWidth="xl">
				<Box sx={{ textAlign: "center", mb: 8 }} data-aos="fade-up">
					<SectionTitle>{t("howItWorks.title")}</SectionTitle>
					<SectionSubtitle>
						{t("howItWorks.subtitle")}
					</SectionSubtitle>
				</Box>

				<StepsContainer>
					{steps.map((step, index) => (
						<React.Fragment key={index}>
							<StepCard
								data-aos="fade-up"
								data-aos-delay={index * 100}
								data-aos-duration="800">
								<StepNumber>{step.number}</StepNumber>
								<StepIconWrapper>{step.icon}</StepIconWrapper>
								<StepTitle>{step.title}</StepTitle>
								<StepDescription>{step.description}</StepDescription>
							</StepCard>

							{index < steps.length - 1 && (
								<ConnectorLine
									data-aos="fade-left"
									data-aos-delay={index * 100 + 200}>
									<AnimatedArrow>
										<ArrowForward sx={{ fontSize: 32 }} />
									</AnimatedArrow>
								</ConnectorLine>
							)}
						</React.Fragment>
					))}
				</StepsContainer>
			</Container>
		</HowItWorksContainer>
	);
};

export default HowItWorks;
